import React, { useEffect } from "react";

const NewsSection = () => {
  const newsItems = [
    {
      title: "Envision Launches New AI Platform",
      category: "Company News",
      image: "/image/196bs_FutureScopeofAIandMLinIndia.jpg",
      details:
        "Envision unveils its new AI platform to revolutionize industrial automation and enhance productivity.",
    },
    {
      title: "Mechanical Division Expands",
      category: "Mechanical",
      image: "/image/indautomate.jpg",
      details:
        "Our mechanical engineering team is expanding with new R&D facilities and advanced machinery.",
    },
    {
      title: "Cutting-Edge Web Development",
      category: "Web Development",
      image: "/image/web-programming-languages.webp",
      details:
        "Envision's web development team builds high-performance, scalable, and user-friendly websites that deliver exceptional user experiences.",
    },
  ];

  useEffect(() => {
    const style = document.createElement("style");
    style.innerHTML = `
      .news-card {
        transition: box-shadow 0.3s ease, transform 0.3s ease;
      }
      .news-card:hover {
        box-shadow: 0 12px 28px rgba(0,0,0,0.16);
        transform: translateY(-4px);
      }

      @media (max-width: 768px) {
        .news-card {
          height: auto !important;
        }
        .news-card img {
          position: relative !important;
          height: 190px !important;
          transform: none !important;
        }
        .news-card .details {
          position: relative !important;
          transform: none !important;
          padding-top: 18px !important;
          background: #fff !important;
        }
        .news-card:hover {
          transform: none;
        }
      }
    `;
    document.head.appendChild(style);
    return () => {
      document.head.removeChild(style);
    };
  }, []);

  const styles = {
    section: {
      padding: "15px 20px",
      maxWidth: "1350px",
      margin: "auto",
    },
    heading: {
      fontSize: "34px",
      fontWeight: "700",
      marginBottom: "8px",
      textAlign: "center",
      letterSpacing: "0px",
      fontFamily: "'Segoe UI', Arial, sans-serif",
    },
    subheading: {
      textAlign: "center",
      color: "#6b7280",
      fontSize: "14px",
      marginBottom: "36px",
      fontFamily: "'Segoe UI', Arial, sans-serif",
    },
    grid: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
      gap: "24px",
    },
    card: {
      position: "relative",
      height: "380px",
      overflow: "hidden",
      borderRadius: "10px",
      boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
      cursor: "pointer",
      background: "#fff",
      border: "1px solid #eef0f2",
    },
    image: {
      width: "100%",
      height: "100%",
      objectFit: "cover",
      transition: "transform 0.6s ease-in-out",
      position: "absolute",
      top: "0",
      left: "0",
      zIndex: 2,
    },
    details: {
      backgroundColor: "#fff",
      position: "absolute",
      top: "0",
      left: "0",
      width: "100%",
      height: "100%",
      padding: "22px",
      boxSizing: "border-box",
      transform: "translateX(-100%)",
      transition: "transform 0.6s ease-in-out",
      zIndex: 1,
      paddingTop: "130px",
      display: "flex",
      flexDirection: "column",
    },
    category: {
      display: "inline-block",
      background: "#025261",
      color: "#fff",
      fontSize: "11px",
      fontWeight: "600",
      letterSpacing: "0.5px",
      textTransform: "uppercase",
      padding: "4px 12px",
      borderRadius: "20px",
      marginBottom: "12px",
      width: "fit-content",
      fontFamily: "'Segoe UI', Arial, sans-serif",
    },
    title: {
      fontSize: "16px",
      fontWeight: "700",
      marginBottom: "8px",
      color: "#111827",
      lineHeight: "1.4",
      fontFamily: "'Segoe UI', Arial, sans-serif",
    },
    paragraph: {
      fontSize: "13px",
      color: "#5b6270",
      textAlign: "left",
      lineHeight: "1.6",
      fontFamily: "'Segoe UI', Arial, sans-serif",
      margin: 0,
    },
  };

  const handleMouseEnter = (e) => {
    if (window.innerWidth > 768) {
      const img = e.currentTarget.querySelector("img");
      const details = e.currentTarget.querySelector(".details");
      img.style.transform = "translateX(100%)";
      details.style.transform = "translateX(0)";
    }
  };

  const handleMouseLeave = (e) => {
    if (window.innerWidth > 768) {
      const img = e.currentTarget.querySelector("img");
      const details = e.currentTarget.querySelector(".details");
      img.style.transform = "translateX(0)";
      details.style.transform = "translateX(-100%)";
    }
  };

  return (
    <div style={styles.section}>
      <h2 style={styles.heading}>
        <span style={{ color: "#025261" }}>Latest </span>
        <span style={{ color: "#d4af37" }}>News</span>
      </h2>
      <p style={styles.subheading}>Updates, milestones and stories from Envision</p>

      <div style={styles.grid}>
        {newsItems.map((item, index) => (
          <div
            key={index}
            className="news-card"
            style={styles.card}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
          >
            <img src={item.image} alt={item.title} style={styles.image} />
            <div className="details" style={styles.details}>
              <span style={styles.category}>{item.category}</span>
              <h3 style={styles.title}>{item.title}</h3>
              <p style={styles.paragraph}>{item.details}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default NewsSection;